import React from 'react';

export default function Video() {
	const videoRef = React.useRef(null);

	React.useEffect(() => {
		getVideo();
	}, [videoRef]);

	const getVideo = () => {
		navigator.mediaDevices.getUserMedia({ video: { width: 720 } }).then((stream) => {
			let video = videoRef.current;
			video.srcObject = stream;
			video.play();
		});
	};

	return (
		<div id="videoContainer" className="container">
			<div id="screenWrapper" className="screenWrapper">
				<video id="videoFeed" className="videoFeed" ref={videoRef} />
				{/* <image id="videoFeed" className="videoFeed" src={testVideo} /> */}
			</div>
		</div>
	);
}
